// @ts-nocheck
/* eslint-disable react/display-name */
/* eslint-disable react/no-multi-comp */
import _ from "lodash";
import React from "react";

import { config, useTransition, animated } from "react-spring";

import { Icon } from "kit/ui";


import AlertProgressBar from "./Alert.ProgressBar.view";

import * as styles from "../Alert.styles.js";


type ComponentPropTypes = {
  alerts: Object[];
  position: string;
  handleHide: () => void;
  handleConfirm: () => void;
  handleCancel: () => void;
}

const GroupItem = (props: ComponentPropTypes) => {

  const {
    alerts = [],
    position = "bottom-right",
    handleHide,
    handleConfirm,
    handleCancel
  } = props;

  const transitions = useTransition(
    alerts,
    item => item.id,
    {
      config: config.stiff,
      from: {
        opacity: 0,
        height: 0,
        marginBottom: 0,
        transform: "translate3d(0, 100%, 0)"
      },
      enter: item => async next => {
        const elem = document.getElementById(item.id) || {};
        /* eslint-disable-next-line */
        await next({
          opacity: 1,
          // height: "auto"
          height: _.defaultTo(elem.offsetHeight, "auto"),
          transform: "translate3d(0, 0, 0)",
          marginBottom: 10
        });
        /* eslint-disable-next-line */
        // await next({
        //   height: "initial"
        // });
      },
      leave: item => async(next) => {
        // const elem = document.getElementById(item.id) || {};
        /* eslint-disable-next-line */
        await next({
          opacity: 0,
          marginBottom: 0,
          transform: "translate3d(0, 100%, 0)"
        });
        /* eslint-disable-next-line */
        await next({
          height: 0
        });
      }
    }
  );

  return (
    <div
      css={[
        styles.base,
        styles.positions[position]
      ]}>

      {_.map(transitions, ({ item: alertItem, props: styleProps }) => (
        <div
          css={styles.itemWrapper}
          key={alertItem.id}>
          <animated.div
            style={styleProps}>
            {!!alertItem && (
              <div css={styles.itemHolder}>
                <div
                  css={[
                    styles.item,
                    styles.types[alertItem.alertType]
                  ]}
                  id={alertItem.id}>
                  {!!alertItem.icon && (
                    <Icon css={styles.iconStyles} name={`fas ${alertItem.icon}`} />
                  )}
                  <div
                    {...alertItem.alertProps}>
                    {!!alertItem.dismissable && (
                      <i
                        css={styles.closeIcon}
                        onClick={() => handleHide(alertItem.id)} />
                    )}

                    <div css={styles.itemContent}>
                      <div css={styles.itemHeader}>
                        {alertItem.header}
                      </div>
                      <p>{alertItem.content}</p>
                    </div>

                    {!_.isEmpty(alertItem.actions) && (
                      <div css={styles.itemActions}>
                        {_.map(alertItem.actions, (actionItem, index) => (
                          <button
                            size={_.defaultTo(alertItem.size, "tiny")}
                            content={`ACTION${index}`}
                            {...actionItem}
                            key={index}
                            onClick={() => {
                              handleConfirm(alertItem.id);
                              handleHide(alertItem.id);
                              _.invoke(actionItem, "onClick");
                            }} />
                        ))}
                      </div>
                    )}


                  </div>
                  {!!alertItem.autoDismiss && (
                    <AlertProgressBar duration={alertItem.autoDismiss} />
                  )}
                </div>

              </div>
            )}
          </animated.div>
        </div>
      ))}

    </div>
  );

};

export default GroupItem;
